export default __webpack_public_path__ + "static/media/ord-stock-nv.b2b7bcf6.png";